"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = exports.MobileWrapper = exports.CatalogueWrapper = exports.CatalogueLink = exports.CatalogueDetailButton = exports.Catalogue = exports.CallToActionWrapper = exports.CallToAction = exports.CTAText = void 0;
var _components = require("@ori-ui/components");
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
const Root = exports.Root = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(6, 12),
  [theme.breakpoints.down('md')]: {
    a: {
      width: '100%'
    }
  }
}));
const CatalogueWrapper = exports.CatalogueWrapper = (0, _mui.styled)('div', {
  shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})(({
  theme
}) => ({
  margin: theme.spacing(3, 3, 10, 3),
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  gap: theme.spacing(6),
  [theme.breakpoints.up('md')]: {
    margin: theme.spacing(6, 12, 0, 12)
  }
}));
const Catalogue = exports.Catalogue = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'start',
  a: {
    minWidth: 160
  }
}));
const CatalogueDetailButton = exports.CatalogueDetailButton = (0, _mui.styled)(_components.Button)(({
  theme,
  hoverEffect = false
}) => ({
  margin: theme.spacing(2, 'auto'),
  '&:hover': {
    background: hoverEffect ? theme.palette.grey : 'none'
  }
}));
const CatalogueLink = exports.CatalogueLink = (0, _mui.styled)('a')(({
  theme,
  hoverEffect = false
}) => ({
  textDecoration: 'none',
  '&:hover': {
    color: hoverEffect ? theme.palette.default.light : 'none'
  }
}));
const CallToActionWrapper = exports.CallToActionWrapper = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'start',
  margin: theme.spacing(0, 12)
}));
const CallToAction = exports.CallToAction = (0, _mui.styled)('div')(({
  theme
}) => ({
  width: 330,
  marginBottom: theme.spacing(4)
}));
const CTAText = exports.CTAText = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  fontSize: '1.2rem',
  textAlign: 'center',
  textDecoration: 'underline',
  textTransform: 'uppercase',
  textUnderlineOffset: theme.spacing(1),
  textDecorationThickness: 2,
  margin: theme.spacing(3, 0, 0),
  fontWeight: theme.typography.fontWeightBold,
  [theme.breakpoints.up('md')]: {
    color: theme.palette.text.primary,
    fontSize: theme.typography.subtitle1.fontSize,
    textAlign: 'left',
    textDecoration: 'none',
    textTransform: 'none',
    textUnderlineOffset: 'auto',
    textDecorationThickness: 'auto',
    margin: theme.spacing(0)
  }
}));
const MobileWrapper = exports.MobileWrapper = (0, _mui.styled)('div')(() => ({
  height: 103,
  width: '100%'
}));
